// npm run pro-api and build-aws: the web works through the production backend API instead of Firebase
export const environment = {
	production: false,
	firebaseEmulatorEnabled: false,
	apiLocalEnabled: false,
	repositoryWithFirebase: false,
};
